export var getDarkPalette = function (palette) {
    return palette === 'disabled'
        ? 'gray900'
        : palette === 'primary'
            ? 'primary500'
            : palette + "600";
};
export var getLightPalette = function (palette) {
    return palette === 'disabled'
        ? 'gray900'
        : palette === 'primary'
            ? 'primary500'
            : palette + "400";
};
export var getImportantOrPrimaryPalette = function (palette) {
    return palette === 'disabled'
        ? 'gray900'
        : palette === 'danger' || palette === 'warning'
            ? palette + "500"
            : 'primary500';
};
export var getPaletteText = function (palette) {
    var needsDarkText = palette === 'warning' || palette === 'disabled';
    return needsDarkText ? 'primary500' : 'white';
};
//# sourceMappingURL=paletteConversions.js.map